import { render, staticRenderFns } from "./toolbarTitle.vue?vue&type=template&id=1652d067&scoped=true"
import script from "./toolbarTitle.vue?vue&type=script&lang=js"
export * from "./toolbarTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1652d067",
  null
  
)

export default component.exports